import * as types from './types';

export const deactivateCompanyRequest = (data) => ({ type: types.DEACTIVATE_COMPANY_REQUEST, data });
export const deactivateCompanyRequestFailure = (error) => ({ type: types.DEACTIVATE_COMPANY_REQUEST_FAILURE, error });
export const deactivateCompanyRequestSuccess = (data) => ({ type: types.DEACTIVATE_COMPANY_REQUEST_SUCCESS, data });

export const getCompanyRequest = (data) => ({ type: types.GET_COMPANY_REQUEST, data });
export const getCompanyRequestFailure = (error) => ({ type: types.GET_COMPANY_REQUEST_FAILURE, error });
export const getCompanyRequestSuccess = (data) => ({ type: types.GET_COMPANY_REQUEST_SUCCESS, data });

export const getCompanyLogoRequest = (data) => ({ type: types.GET_COMPANY_LOGO_REQUEST, data });
export const getCompanyLogoRequestFailure = (error) => ({ type: types.GET_COMPANY_LOGO_REQUEST_FAILURE, error });
export const getCompanyLogoRequestSuccess = (data) => ({ type: types.GET_COMPANY_LOGO_REQUEST_SUCCESS, data });

export const selectCompanyEntityRequest = (data) => ({ type: types.SELECT_COMPANY_ENTITY_REQUEST, data });
export const selectCompanyEntityRequestFailure = (error) => ({ type: types.SELECT_COMPANY_ENTITY_REQUEST_FAILURE, error });
export const selectCompanyEntityRequestSuccess = (data) => ({ type: types.SELECT_COMPANY_ENTITY_REQUEST_SUCCESS, data });

export const updateCompanyRequest = (data) => ({ type: types.UPDATE_COMPANY_REQUEST, data });
export const updateCompanyRequestFailure = (error) => ({ type: types.UPDATE_COMPANY_REQUEST_FAILURE, error });
export const updateCompanyRequestSuccess = (data) => ({ type: types.UPDATE_COMPANY_REQUEST_SUCCESS, data });
